import { render, staticRenderFns } from "./OemDeliveryList.vue?vue&type=template&id=3282bba2&scoped=true&"
import script from "./OemDeliveryList.vue?vue&type=script&lang=js&"
export * from "./OemDeliveryList.vue?vue&type=script&lang=js&"
import style0 from "./OemDeliveryList.vue?vue&type=style&index=0&id=3282bba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282bba2",
  null
  
)

export default component.exports